module.exports = __webpack_public_path__ + "img/4.56ca330f.png";